import clsxm from "@/lib/clsxm";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const TextField: FC<{
  text: string;
  setText: (text: string) => void;
  placeholder?: string;
  isMultiline?: boolean;
  isPassword?: boolean;
  maxChars?: number | null;
  className?: string;
}> = ({text, setText, placeholder = "", isMultiline = false, isPassword = false, maxChars = null, className = ""}) => {
  const {t} = useTranslation();

  return (
    <>
      {!isMultiline ? (
        <input
          className={clsxm(
            "border-good-grey-300 text-neutral-grey-darkest block h-[38px] w-full flex-1 self-center rounded-md border-1 bg-white px-4 py-6 align-middle text-sm leading-normal",
            className,
          )}
          value={text}
          placeholder={t(placeholder)}
          onChange={event => setText(event.target.value)}
          type={isPassword ? "password" : "text"}
        />
      ) : (
        <>
          <textarea
            className={clsxm(
              "border-good-grey-300 text-neutral-grey-darkest block h-[100px] w-full flex-1 resize-y self-center rounded-md border-1 bg-white px-4 py-6 align-middle text-sm leading-normal",
              className,
            )}
            value={text}
            placeholder={t(placeholder)}
            onChange={event => setText(event.target.value)}
            cols={30}
            maxLength={maxChars ?? undefined}
          />
          {maxChars && (
            <div className="relative">
              <span className="text-good-grey-400 absolute -top-6 right-2">
                {text.length}/{maxChars}
              </span>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TextField;
